import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "9.5",
      cy: "9.5",
      r: "8.5",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "9.529",
      cy: "13.8",
      r: "1.2",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M9.067 10.671 8.02 5.655C7.87 4.788 8.574 4 9.5 4c.93 0 1.636.796 1.478 1.666l-1.095 5.008c-.08.436-.74.434-.816-.003Z"
    }, null, -1)
  ]))]))
}
export default { render: render }